/* ═══════════════════════════════════════════════════════════════════════
   FizzyIQ — PDP Testimonials carousel
   Direct port of the inline <script> from the design file. Three jobs:
     1. Prev/next buttons call rail.scrollBy() with one card width + gap.
     2. Scroll listener updates the "01 / 10" counter (rounds scroll
        position to nearest card index).
     3. Same listener updates the .t1-nav-progress-fill width based on
        scrollLeft / maxScroll. Min fill of 12% so the bar always reads
        as a progress indicator, not as empty.
     4. Prev disables at scrollLeft ≤ 4; next disables at scrollLeft ≥
        max - 4 (4px tolerance for sub-pixel scroll positions).
   No carousel library. ~30 lines of vanilla JS.
   ═══════════════════════════════════════════════════════════════════════ */

(function () {
  // Idempotency guard — if the section appears twice on the page (e.g.,
  // theme editor preview), or if multiple sections load this asset,
  // the IIFE only runs once.
  if (window.__fizzyTestimonialsBooted) return;
  window.__fizzyTestimonialsBooted = true;

  function boot() {
    var rail = document.getElementById('t1Rail');
    var prev = document.getElementById('t1Prev');
    var next = document.getElementById('t1Next');
    var fill = document.getElementById('t1Fill');
    var cur  = document.getElementById('t1Cur');
    if (!rail || !prev || !next || !fill || !cur) return;

    var total = rail.children.length;
    // .t1-rail-wrap is rail's parent — used for the at-start / at-end
    // class toggles that drive the edge-fade visibility (see CSS).
    var wrap = rail.parentElement;

    function cardW() {
      var first = rail.children[0];
      if (!first) return 0;
      return first.getBoundingClientRect().width + 20; // gap = 20px
    }

    function update() {
      var scroll = rail.scrollLeft;
      var max = rail.scrollWidth - rail.clientWidth;
      var pct = max > 0 ? scroll / max : 0;
      fill.style.transform = 'scaleX(' + Math.max(0.12, pct * 0.88 + 0.12) + ')';

      var w = cardW();
      var idx = w > 0 ? Math.min(total, Math.round(scroll / w) + 1) : 1;
      cur.textContent = String(idx).padStart(2, '0');

      var atStart = scroll <= 4;
      var atEnd = scroll >= max - 4;
      prev.disabled = atStart;
      next.disabled = atEnd;
      // Toggle fade visibility — hide the left fade when nothing is
      // scrolled out to the left (so the first card reads fully),
      // and hide the right fade when there's nothing more to reveal.
      if (wrap) {
        wrap.classList.toggle('at-start', atStart);
        wrap.classList.toggle('at-end', atEnd);
      }
    }

    prev.addEventListener('click', function () {
      rail.scrollBy({ left: -cardW(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      rail.scrollBy({ left: cardW(), behavior: 'smooth' });
    });
    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    /* Video cards — show the clip's FIRST FRAME as a thumbnail (preload
       metadata + a #t media fragment, attached lazily near the viewport) so
       we don't stream video bytes on first paint. No autoplay: the full clip
       loads + plays only when the user clicks the card. Only one plays at a
       time. Sam: 2026-06-07. */
    var videoCards = rail.querySelectorAll('.t1-card.has-video');
    var thumbAttachers = [];
    Array.prototype.forEach.call(videoCards, function (card) {
      var v = card.querySelector('.t1-card-video');
      if (!v) return;
      var url = v.getAttribute('data-src') || '';
      var thumbAttached = false;

      function attachThumb() {
        if (thumbAttached || !url) return;
        thumbAttached = true;
        v.preload = 'metadata';
        // #t media fragment → browser seeks to ~the first frame and paints it
        // as the thumbnail without fetching the whole clip.
        v.setAttribute('src', url.indexOf('#') === -1 ? url + '#t=0.1' : url);
        // Some browsers won't paint a frame until a seek actually happens —
        // nudge currentTime once metadata is ready so the thumb isn't black.
        v.addEventListener('loadedmetadata', function () {
          try { if (v.paused) v.currentTime = 0.1; } catch (e) {}
        }, { once: true });
      }
      thumbAttachers.push(attachThumb);

      function pauseOthers() {
        Array.prototype.forEach.call(videoCards, function (other) {
          if (other === card) return;
          var ov = other.querySelector('.t1-card-video');
          if (ov && !ov.paused) ov.pause();
          other.classList.remove('is-playing');
        });
      }
      function playClip() {
        attachThumb();
        pauseOthers();
        v.preload = 'auto';
        v.muted = false;
        try { v.currentTime = 0; } catch (e) {}
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
        card.classList.add('is-playing');
      }
      function pauseClip() {
        if (!v.paused) v.pause();
        card.classList.remove('is-playing');
      }

      // Click the card toggles play / pause for that clip.
      card.addEventListener('click', function () {
        if (v.paused) playClip(); else pauseClip();
      });
      v.addEventListener('ended', function () { card.classList.remove('is-playing'); });
      v.addEventListener('pause', function () { card.classList.remove('is-playing'); });
    });

    // Attach EVERY card's first-frame thumbnail once the rail nears the
    // viewport. Cards scrolled off to the right in this horizontal rail are
    // outside the viewport, so a per-card observer left later ones black
    // until they were scrolled to — attaching them all here fixes that.
    // Sam 2026-06-07.
    function attachAllThumbs() { thumbAttachers.forEach(function (fn) { fn(); }); }
    // Paint the first-frame thumbnails AHEAD of scroll: attach during idle time
    // after load so the frames decode before the section enters view (no black
    // flash). preload=metadata only — no full-clip bytes are streamed. The IO
    // below stays as a fast-scroll safety net. Sam 2026-06-24.
    if ('requestIdleCallback' in window) {
      requestIdleCallback(attachAllThumbs, { timeout: 2500 });
    } else {
      setTimeout(attachAllThumbs, 1200);
    }
    if ('IntersectionObserver' in window) {
      var railIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { attachAllThumbs(); railIO.disconnect(); }
        });
      }, { rootMargin: '1200px 0px' });
      railIO.observe(rail);
    } else {
      attachAllThumbs();
    }
  }

  // Clinician carousel — native horizontal scroll-snap (swipe/drag), like the
  // parent rail. Dots reflect + drive scroll position. Sam 2026-06-09.
  function initClinCarousel() {
    var car = document.querySelector('[data-clin-carousel]');
    var track = car && car.querySelector('[data-clin-track]');
    var vp = car && car.querySelector('.t1-clin-viewport');
    if (!car || !track || !vp) return;
    var n = track.children.length;
    var dotsWrap = car.querySelector('[data-clin-dots]');
    if (n < 2) { if (dotsWrap) dotsWrap.style.display = 'none'; return; }
    var dots = [];
    function cardW() { return track.children[0] ? track.children[0].getBoundingClientRect().width : vp.clientWidth; }
    function activeIdx() { var w = cardW(); return w > 0 ? Math.max(0, Math.min(n - 1, Math.round(vp.scrollLeft / w))) : 0; }
    function syncDots() { var a = activeIdx(); for (var j = 0; j < dots.length; j++) dots[j].classList.toggle('is-active', j === a); }
    if (dotsWrap) {
      for (var k = 0; k < n; k++) {
        var d = document.createElement('button');
        d.type = 'button'; d.className = 't1-clin-dot'; d.setAttribute('aria-label', 'Show review ' + (k + 1));
        (function (idx) { d.addEventListener('click', function () { vp.scrollTo({ left: idx * cardW(), behavior: 'smooth' }); }); })(k);
        dotsWrap.appendChild(d); dots.push(d);
      }
      dotsWrap.removeAttribute('aria-hidden');
    }
    var raf = null;
    vp.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; syncDots(); });
    }, { passive: true });
    syncDots();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); initClinCarousel(); });
  } else {
    boot(); initClinCarousel();
  }
})();
